import { render, staticRenderFns } from "./MessageThreadAnnouncements.vue?vue&type=template&id=75768f1a&scoped=true&"
import script from "./MessageThreadAnnouncements.vue?vue&type=script&lang=ts&"
export * from "./MessageThreadAnnouncements.vue?vue&type=script&lang=ts&"
import style0 from "./MessageThreadAnnouncements.vue?vue&type=style&index=0&id=75768f1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75768f1a",
  null
  
)

export default component.exports